export * from './getHistogram';
